<template>
  <div v-if="img" id="main-spot">
    <b-image ratio="780by410" class="img-main-spot" :src="img" />
    <h4
      :class="`mist-${language}-h4 has-text-left`"
      v-for="(item, i) in info"
      :key="i"
    >
      {{ item.info[0].text }}
    </h4>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  props: ["img", "info"],
  data() {
    return {
      banner: [],
    };
  },
  computed: {
    language() {
      return this.$store.getters["language/language"];
    },
  },
  mounted() {
    // this.setAnimation();
    // $(document).scroll(this.setAnimation);
  },
  methods: {
    setAnimation() {
      const height = $(window).scrollTop() + $(window).height();
      if ($(`#main-spot`).length > 0) {
        if (height > $(`#main-spot`).offset().top) {
          $(`#main-spot`)
            .addClass("animate__animated animate__fadeInUp")
            .removeClass("invisible");
        }
      }
    },
  },
};
</script>

<style scoped>
.img-main-spot {
  /* max-height: 410px; */
  margin: 31px 0 33px 0;
  /* width: 100%; */
}
@media (max-width: 768px) {
  .img-main-spot {
    margin: 33px 0 16px 0;
  }
}
</style>